import BaseDialog from "@/components/dialog/BaseDialog";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import React, { useState, useEffect } from 'react'
import TodoDetail from '@/views/Dossiers/detail/Todo';
function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function DossierDetail(props) {
    const modalOptions = props?.modalProps?.options;
    const [popup, setPopup] = useState((<></>))

  useEffect(() => {
    if(modalOptions && modalOptions?.calenderItem) {
        setPopup( <TodoDetail data={modalOptions?.calenderItem} nextActionEvent={props?.nextActionEvent} closeModalEvent={props?.closeModal}/> );
    }

    return () => {
      
    };
  }, [modalOptions]);

    return (
        <BaseDialog {...props} nofooter>

            {popup}
        
        </BaseDialog>
    )
}